import { render, staticRenderFns } from "./AdminPostGroupsTableRow.vue?vue&type=template&id=dba33f2a&scoped=true"
import script from "./AdminPostGroupsTableRow.vue?vue&type=script&lang=js"
export * from "./AdminPostGroupsTableRow.vue?vue&type=script&lang=js"
import style0 from "./AdminPostGroupsTableRow.vue?vue&type=style&index=0&id=dba33f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba33f2a",
  null
  
)

export default component.exports